import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import hubEntrepriseFonctionnementStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'hubEntrepriseFonctionnement'
const customImplement: CustomStoreImplementationOptions = hubEntrepriseFonctionnementStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function hubEntrepriseFonctionnementFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('comment-ca-marche-entreprises.title', 'Les 6 étapes d\'une formation Matchers !'),
        $description: $translate('comment-ca-marche-entreprises.description', 'Mettez en place une formation-action 100% financée pour atteindre vos objectifs et faire monter en compétence vos équipes !'),
        $publishedTime: new Date('2023-02-13T07:42:17.435Z'),
        $modifiedTime: new Date('2023-12-18T10:56:33.329Z'),
        // Constants,
        $constants: {
          question1Hidden: false,
          question1Hidden1: null,
          question3Hidden: false,
          question3Hidden1: null,
          question2Hidden: false,
          question2Hidden1: null,
          question4Hidden: false,
          question4Hidden1: null,
          question5Hidden: false,
          question5Hidden1: null,
          question6Hidden: false,
          question6Hidden1: null
        },
        // Data,
        $info: { commentCaMarcheEntreprises: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async rechercherUneFormationClick () {
        await navigateTo({ name: 'Formations' })
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClick () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClickWhenSelected () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container10Click () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container10ClickWhenSelected () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container13Click () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container13ClickWhenSelected () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container16Click () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container16ClickWhenSelected () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container19Click () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container19ClickWhenSelected () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container22Click () {
        this.$elements['question-6'].style = { hidden: this.$constants.question6Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container22ClickWhenSelected () {
        this.$elements['question-6'].style = { hidden: this.$constants.question6Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      prendreRendezVousClick () {
        openUrl('https://meetings.hubspot.com/anne-pavard', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      button1Click () {
        openUrl('https://www.matchers.fr/faq', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      button2Click () {
        // Page not found, has it been deleted ?
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return hubEntrepriseFonctionnementFactory(storeId)()
}

export const hubEntrepriseFonctionnementRaw = hubEntrepriseFonctionnementFactory()
export const hubEntrepriseFonctionnement = () => hubEntrepriseFonctionnementRaw() as MergeCustomStore<typeof hubEntrepriseFonctionnementStoreCustom.instance>
